import React, { useState } from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { CTAContainer, ContentContainer, SubTitle, SuccessContainer, SuccessImage, Title, TitleContainer } from "./SuccessInvitedToPriorityTicket.styles";
import Logo from '../../../../../public/images/logo-new.svg';
import { Button, List, TicketDetails, TicketSummaryPanel } from "../../../../components";
import Link from "next/link";
import { StyledBlueSpan } from "../SuccessPriority/SuccessPriority.styles";
import { SingleShow } from "src/models/Show";
import { SingleSession } from "src/models/Session";
import Image from "next/image";
import { TicketSummaryPanelContainer, TicketSummaryPanelContentContainer } from "src/components/TicketSummaryPanel/TicketSummaryPanel.styles";

interface SuccessPriorityProps extends WithRouterProps {
  firstName: string | undefined;
  bookingInterestId: number | undefined | null;
  ticketHolders: TicketDetails[];
  session: any;
  showName: any
}

const SuccessPriority: React.FC<SuccessPriorityProps> = ({
  firstName,
  bookingInterestId,
  ticketHolders,
  session,
  showName
}) => {
  const router = useRouter();

  return (
    <SuccessContainer
      data-cy="booking-interest-registration-success"
      data-bookinginterest-id={bookingInterestId}>
      <TitleContainer>
        <SuccessImage>
          <Image fill src="/images/email/gifs/flock-happy.gif" alt="TTT Happy Bird Animation" />
        </SuccessImage>
        <Title>
          Congratulations {firstName}!
        </Title>
      </TitleContainer>
      <ContentContainer>
        <SubTitle>
          We just emailed you your priority ticket!
        </SubTitle>
        <TicketSummaryPanel
          ticketHolders={ticketHolders}
          session={session}
          showName={showName}
        />
        <List elements={[
          <>The countdown has begun! Accept your ticket (and any dependant’s tickets) now before time runs out.</>,
          <>Any guests in your booking will have a ticket offer too! Shoot them a text and ask them to check their inbox (and SPAM/Promotions folder) pronto.</>,
          <>If your guests still can’t see the email, check and change their email address in your profile under 
          <Link href="/profile?tab=tickets"><StyledBlueSpan> Applications & Tickets </StyledBlueSpan></Link> - Manage My Booking.</>
        ]} />
      </ContentContainer>
      <CTAContainer>
        <Button data-cy="accept-ticket-now-button" onClick={() => router.push('/profile')}> ACCEPT YOUR TICKET NOW! </Button>
      </CTAContainer>
    </SuccessContainer>
  );
};

export default withRouter(SuccessPriority);
